import React from 'react'

// components
import {
  CRow,
} from '@coreui/react-pro'
import FormTextAreaInput from '../general-input-form/FormTextAreaInput'
import FormSelectInput from '../general-input-form/FormSelectInput'

// helpers
import { singleTimeOffCancellationApprovalTypeOptionSelect } from 'src/helpers/format-options'

const AppFormPendingCancellation = ({
  values,
  handleChange,
  approvalRequestValue,
  handleSelectApprovalRequest,
  errors
}) => {
  return (
    <>
      <CRow className="mb-3 justify-content-center">
        <FormSelectInput
          id='approval_cancellation_request'
          name='approval_cancellation_request'
          colSize='6'
          inputLabel='Approval Decision for Cancellation Request'
          className='mb-3'
          selectOptions={singleTimeOffCancellationApprovalTypeOptionSelect()}
          value={singleTimeOffCancellationApprovalTypeOptionSelect().find(option => option.value === approvalRequestValue) || null}
          handleSelectInput={handleSelectApprovalRequest}
          feedbackInvalid={errors?.approval_cancellation_request}
          invalid={errors?.approval_cancellation_request}
          disabled={false}
          placeholder='Please select...'
        />
        <FormTextAreaInput
          id='cancellation_reason'
          name='cancellation_reason'
          colSize='6'
          inputLabel='Cancellation Reason'
          className='mb-3'
          rows='5'
          disabled={true}
          value={values?.cancellation_reason}
          handleTextAreaInput={handleChange}
          feedbackInvalid={errors?.cancellation_reason}
          invalid={errors?.cancellation_reason}
        />
      </CRow>
      {
        approvalRequestValue === 'approved' && (
          <CRow className="mb-3">
            <FormTextAreaInput
              id='cancellation_rejection_reason'
              name='cancellation_rejection_reason'
              colSize='6'
              inputLabel='Cancellation Rejection Reason'
              className='mb-3'
              rows='5'
              value={values?.cancellation_rejection_reason}
              handleTextAreaInput={handleChange}
              feedbackInvalid={errors?.cancellation_rejection_reason}
              invalid={errors?.cancellation_rejection_reason}
            />
          </CRow>
        )
      }
    </>
  )
}

export default AppFormPendingCancellation
